import { Route, Routes } from 'react-router-dom';
import TeachmodePage from './TeachMode';
import TeachModeDetailsPage from './TeachModeDetails';
import AddImagesCameraPage from './AddImagesCamera';
import AnnotatePage from './AnnotatePage';

const TeachmodeRouter: React.FC = () => {
  // Parent Route /teachmode/
  return(
  <Routes>
    <Route path='' element= {<TeachmodePage/>}/>
    <Route path=':outflowId' element={<TeachModeDetailsPage/>}/>
    {/* <Route path='add-images/:outflowId' element={<AddImagesPage/>}/> */}
    <Route path='add-images/:outflowId' element={<AddImagesCameraPage/>}/>
    <Route path="annotate" element={<AnnotatePage />} />
    <Route path="images" element={<TeachModeDetailsPage />} />
    <Route path="images/:outflowId/:systemName" element={<TeachModeDetailsPage />} />
    <Route path="/annotate" element={<AnnotatePage />} />
    {/* <Route path="add-images/:outflowId/:systemName" element={<AddImagesPage />} /> // Add a placeholder for the Add Images page */}
    <Route path="add-images/:outflowId/:systemName" element={<AddImagesCameraPage />} />
  </Routes>
  )
}

export default TeachmodeRouter